import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Certifications from "./components/Certifications";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import './assets/styles/variables.css'; // Import variables first
import './assets/styles/main.css' // Import main styles
import { useEffect } from "react";

function App() {
  useEffect(() => {
    document.body.style.zoom = "80%";
  }, []);
  return (
    <div>
      <Navbar />
      <Hero />
      <About/>
      <Experience/>
      <Projects />
      <Education />
      <Certifications/>
      {/* <Skills /> */}
      <Contact />
      <Footer/>
    </div>
  );
}

export default App;
